import { FormikTouched, FormikErrors } from 'formik'

// Could be moved to user clients, but would require a formik dependency (which isn't that bad, but we don't feel like it)
export const shouldDisplayErrorMessage = (touched: FormikTouched<any>, errors: FormikErrors<any>) => {
    return Object.keys(touched).length > 0 && Object.keys(errors).length > 0
}
